/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Select, Typography } from "antd";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const { Text } = Typography;

const data = [
  { name: "5 Nov", count: 1000 },
  { name: "7 Nov", count: 1800 },
  { name: "8 Nov", count: 1500 },
  { name: "9 Nov", count: 2800 },
  { name: "10 Nov", count: 3500 },
  { name: "11 Nov", count: 3200 },
  { name: "12 Nov", count: 4200 },
];

const CustomTooltip = ({
  active,
  payload,
  label,
}: {
  active?: boolean;
  payload?: any[];
  label?: string;
}) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-4 shadow-lg rounded-lg border border-slate-100">
        <Text className="text-xs font-semibold text-theme-slate-600 block mb-1">
          {label}, 2025
        </Text>
        <Text className="text-sm font-bold text-orange-500">
          Enrollments: {payload[0].value.toLocaleString()}
        </Text>
      </div>
    );
  }
  return null;
};

export default function EnrollmentTrendChart() {
  return (
    <Card
      className="shadow-sm bordered-card custom-card"
      title={
        <span className="text-theme-slate-800 text-lg font-medium">
          Enrollment Trend
        </span>
      }
      extra={
        <Select
          defaultValue="7days"
          size="small"
          className="w-32"
          options={[{ label: "Last 7 days", value: "7days" }]}
        />
      }
    >
      <div className="h-80 w-full mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#E2E8F0"
            />
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#64748B", fontSize: 12 }}
              dy={10}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#64748B", fontSize: 12 }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#FC8415"
              strokeWidth={2}
              dot={{ r: 4, fill: "#FC8415", strokeWidth: 2, stroke: "#fff" }}
              activeDot={{
                r: 6,
                fill: "#FC8415",
                stroke: "#fff",
                strokeWidth: 2,
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
